import { useMemo } from 'react';
import { useGetRiskInsightsAvailableDatesQuery } from 'src/app/portfolio/state/api/riskInsightsEngineSlice';
import { groupDatesIntoQuarters, type TimePeriodOption } from 'src/shared/utils/timePeriodHelpers';

// Fetches the organisation's available risk-insights assessment dates and buckets them into
// quarters for the portfolio-level Time Period filter. Extracted after this "fetch + bucket"
// shape was duplicated across several portfolio GNR views (see SiteList.tsx and
// SiteNatureRiskOverview.tsx for the earlier, site-level duplicates of this same pattern).
const useGnrAvailableTimePeriods = (businessCentralId: string): { timePeriods: TimePeriodOption[] } => {
    const { data } = useGetRiskInsightsAvailableDatesQuery({ businessCentralId }, { skip: !businessCentralId });

    const timePeriods = useMemo(() => groupDatesIntoQuarters(data?.organisation?.riskInsightsAvailableDates ?? []), [data]);

    return { timePeriods };
};

export default useGnrAvailableTimePeriods;
